import BaseModule from './base-module';

// 首页
class Order extends BaseModule {
  // 订单列表接口
  orderList(params) {
    return this.post('/admin/i_lis/orderList', params);
  }

  // 订单详情接口
  orderDetail(params) {
    return this.post('/admin/i_lis/orderDetail', params);
  }

  // 取消订单接口
  orderCancel(params) {
    return this.post('/admin/i_lis/cancel', params);
  }

  // 修改订单价格接口
  updatePrice(params) {
    return this.post('/admin/i_lis/updatePrice', params);
  }

  // 管理员扣款接口
  subtractAmount(params) {
    return this.post('/admin/i_lis/subtractAmount', params);
  }

  // 打印全部面单
  printAll(params) {
    return this.post('/admin/i_lis/printAll', params);
  }

  // 订单列表-订单数量统计
  orderCount(params) {
    return this.post('/admin/i_lis/orderCount', params);
  }

  // 订单列表-获取用户信息
  getUserInfo(params) {
    return this.post('/admin/i_lis/userDetail', params);
  }

  // 根据日期查看订单
  dayView(params) {
    return this.post('/admin/i_lis/dayView', params);
  }

  setComplete(params) {
    return this.post('/admin/i_lis/setComplete', params);
  }
}

export default new Order();
